import React from "react";
import CardPreview from "../CardPreview/CardPreview";

export default function CardSelectorModal({
  columns,
  sourceColumns = columns,
  listDescriptors = [],
  onSelect,
  onClose,
}) {
  const columnsWithConfig = listDescriptors
    .map((config, colIndex) => ({
      config,
      colIndex,
      items: columns[colIndex] ?? [],
    }))
    .filter(({ config, items }) => !!config && items.length > 0);

  const handleCardClick = (colIndex, eventIndex, item) => {
    const columnId = listDescriptors[colIndex]?.id ?? colIndex;
    const sourceColumn = sourceColumns[colIndex] ?? [];
    const sourceEventIndexById = sourceColumn.findIndex((entry) => entry?.id === item?.id);
    const sourceEventIndexByRef = sourceColumn.findIndex((entry) => entry === item);
    const sourceEventIndex =
      sourceEventIndexById >= 0
        ? sourceEventIndexById
        : sourceEventIndexByRef >= 0
          ? sourceEventIndexByRef
          : eventIndex;
    const eventId = item?.id ?? sourceEventIndex;
    onSelect({ columnId, eventId });
    onClose();
  };

  return (
    <div className="plan-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Karte auswählen">
      <div className="plan-modal" onClick={(e) => e.stopPropagation()}>
        <div className="plan-modal-header">
          <h3>Karte hinzufügen</h3>
          <button type="button" className="plan-modal-close" onClick={onClose} aria-label="Schliessen">
            ×
          </button>
        </div>
        <div className="plan-modal-content">
          {columnsWithConfig.length === 0 ? (
            <p>Keine Karten fuer diesen Zeitslot gefunden.</p>
          ) : null}
          {columnsWithConfig.map(({ config, colIndex, items }) => {
            const label = config?.label;
            return (
              <div key={config.id ?? colIndex} className="plan-modal-column">
                <h4 className="plan-modal-column-title">{label}</h4>
                <div className="plan-modal-cards">
                  {items.map((item, eventIndex) => (
                    <CardPreview
                      key={item?.id ?? eventIndex}
                      item={item}
                      mode="minimal"
                      columnId={listDescriptors[colIndex]?.id ?? colIndex}
                      eventId={item?.id ?? eventIndex}
                      onClick={() => handleCardClick(colIndex, eventIndex, item)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleCardClick(colIndex, eventIndex, item);
                        }
                      }}
                      wrapperClassName="card-preview--square plan-selector-card"
                      label={label}
                      columnType={config.type}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
